









import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormQuestion } from '@/interfaces/registration/FormQuestion';

@Component
export default class QuestionSection extends Vue {
  @Prop({ default: () => { return {}; } }) readonly formQuestion!: FormQuestion;
}
